import {debounce} from "./utils";
import {timeline, data, layers, map, layout} from "./common";
import * as d3 from "d3-selection";
import dayjs from "dayjs/esm";
import ScrollBooster from 'scrollbooster';
import {
  displayWindForecasts,
  displayWavesForecasts,
  renderWindSensors,
  displayForecastDetails,
  displayPOIs,
  renderWaveSensors,
  renderTempSensors, displayPiafLayer, refreshWindSensorsData, refreshWaveSensorsData, refreshTempSensorsData,
  displayWaterTemp
} from "./data";
import {config} from "./config";

export function initTimeline(timestamp) {
  // console.time('initTimeline');
  let i;
  timeline.timelineReference = timestamp - 345600;
  timeline.timelineSteps = [];
  for (i = 0; i < timeline.timelineStepsCount; i++) {
    timeline.timelineSteps.push([timeline.timelineReference + (i * timeline.timelineStep), timeline.timelineReference + ((i + 1) * timeline.timelineStep)]);
  }
  return fetch(`https://private2.windmorbihan.com/mesures/history.json`).then(resp => resp.json())
    .then(jsonData => {
      data.timelineData = jsonData;
      renderTimeline();
      if (!timeline.keyBoardSetUp) {
        setUpKeyboardActions();
      }
      // console.timeEnd('initTimeline');
    });
}

export function renderTimeline(skipScale = false) {
  // console.time('renderTimeline');

  d3.select("#timeline_steps").selectAll(".tl_item").data(timeline.timelineSteps).join("div")
    .attr("class", function(step) {
      return "tl_item" + ((timeline.timelineActiveStep && d3.select(timeline.timelineActiveStep).datum()[0] === step[0]) ? ' active' : '') +
        (data.timelineData[step[0]] ? ' tl_obs' : '');
    })
    .attr("data-ts", function(step) { return step[0]; })
    .attr("data-rt", function(step) { return data.timelineData[step[0]] ? '1' : null; })
    .attr("data-fc", function(step) { return (step[0] % 3600 === 0) ? (dayjs.unix(step[0]).format("HH[h]")) : null; })
    .attr("data-day", function(step) { return (new Date(step[0] * 1000).toLocaleString().indexOf('00:00:00') !== -1) ? dayjs.unix(step[0]).format("ddd DD/MM").toUpperCase() : null; })
    .on("click", function(evt) {
      if (!timeline.moving) {
        const clickedTs = evt.target.getAttribute('data-ts');
        console.debug('clicked ts: ' + new Date(parseInt(clickedTs) * 1000));
        updateTimelinePosition(clickedTs);
      }
    });
  const now = new Date().getTime() / 1000;

  updateTimelineDatetime(now, false);

  if (!timeline.timelineSlider) {
    // console.time('initSlider');
    initTimelineSlider(now);
    // console.timeEnd('initSlider');
  }
  if (!skipScale) {
    scaleTimelineSlider(timeline.details, timeline.details);
  }
  // console.timeEnd('renderTimeline');
}

let debouncedSelectTimeline = debounce(function(ts) {
  selectTsTimeline(ts);
}, 5);

let debouncedRefreshForecasts = debounce(function() {
  refreshForecastsLayers();
}, 100);

export function scaleTimelineSlider(updateMetrics, details) {
  // console.time('scaleTimelineSlider');
  timeline.skipUpdate = true;
  if (updateMetrics) {
    timeline.timelineSlider.updateMetrics();
  }
  timeline.timelineActiveStep ||= defaultActiveStep();
  const currentTs = parseInt(timeline.timelineActiveStep.getAttribute('data-ts')),
    currentStep = computeStep(currentTs);
  timeline.timelineSlider.setPosition({x: (currentStep * (details ? timeline.detailsStepWidth : timeline.stepWidth)) - layout.width / 2, y: 0});
  updateTimelineDatetime(currentTs, details);
  setTimeout(() => {
    timeline.skipUpdate = false;
    timeline.details = details;
  }, 2000);
  // console.timeEnd('scaleTimelineSlider');
}

export function initTimelineSlider(now) {
  let ts, timelineElt = document.querySelector("#timeline");
  const stepsCount = timeline.timelineStepsCount;

  timeline.timelineSlider = new ScrollBooster({
    viewport: document.querySelector("#timeline_viewport"),
    content: document.querySelector("#timeline_content"),
    scrollMode: 'transform',
    direction: 'horizontal',
    emulateScroll: true,
    lockScrollOnDragDirection: 'horizontal',
    friction: 0.1,
    onUpdate: (state) => {
      timeline.moving = (timeline.scrolling && state.isMoving) || (state.dragOffset.x !== 0 && state.isMoving);
      if (!state.isMoving) {
        timeline.scrolling = false;
      }
      if (!timeline.skipUpdate) {
        const currentStep = Math.round(((state.position.x + layout.width / 2) / (stepsCount * (timeline.details ? timeline.detailsStepWidth : timeline.stepWidth))) * stepsCount) - 1;
        ts = timeline.timelineSteps[currentStep][1];
        console.debug('onUpdate: ' + new Date(ts * 1000) + ' - currentStep: ' + currentStep.toString());
        if (!layout.edit) {
          timelineElt.classList.remove('no_focus');
        }
        debouncedSelectTimeline(ts);
      }
    },
    onWheel: () => {
      timeline.scrolling = true;
    }
  });
}

export function appendToTimeline(newMeasures) {
  let i, createdAt;
  for (i = 0; i < newMeasures.length; i++) {
    createdAt = parseInt(Object.keys(newMeasures[i].created)[0]);
    for (let s of timeline.timelineSteps) {
      if (createdAt >= s[0] && createdAt < s[1]) {
        data.timelineData[s[0]] = data.timelineData[s[0]] || {}
        if (!data.timelineData[s[0]][newMeasures[i].nid]) {
          data.timelineData[s[0]][newMeasures[i].nid] = {
            nid: newMeasures[i].nid,
            ts: createdAt,
            wind_dir_true: newMeasures[i]['wind_dir_true'],
            wind_pow_knot: newMeasures[i]['wind_pow_knot'],
            wind_pow_knot_max: newMeasures[i]['wind_pow_knot_max']
          };
        }
      }
    }
  }
}

function toggleStepTimeline(elt) {
  let activeItem = document.querySelector('#timeline_steps .tl_item.active')
  if (activeItem) {
    activeItem.classList.remove('active')
  }
  elt.classList.add('active');
  timeline.timelineActiveStep = elt;
  timeline.timelineActiveShortStep = null;
}

export function updateTimelineDatetime(ts, details) {
  const hourLabel = dayjs.unix(ts).format("HH[h]mm").replace('.', ''), hour = parseInt(dayjs.unix(ts).format("HH"));
  const hoursSpan = details ? timeline.hoursCountDetails : timeline.hoursCount;
  timeline.hourLabel.innerHTML = hourLabel;
  if (hour <= hoursSpan) {
    timeline.dateLabel.style.opacity = `${(hoursSpan - hour - 1) / hoursSpan}`;
    timeline.dateLabel.innerHTML = dayjs.unix(ts - 86400).format("ddd DD/MM").replace('.', '').toUpperCase();
  } else if (hour > hoursSpan) {
    timeline.dateLabel.style.opacity = '1';
    timeline.dateLabel.innerHTML = dayjs.unix(ts).format("ddd DD/MM").replace('.', '').toUpperCase();
  }
  if (timeline.dateLabel.innerHTML === '') {
    timeline.dateLabel.innerHTML = dayjs.unix(ts).format("ddd DD/MM").replace('.', '').toUpperCase();
  }

  console.debug('updateTimelineDatetime: ' + JSON.stringify({ts, hourLabel, hour, hoursSpan}));
}

export function toggleTimeline(btn) {
  if (btn.classList.contains('playing') && timeline.timelineInterval) {
    btn.classList.remove('playing');
    btn.querySelector("i").classList.replace('fa-pause', 'fa-play');
    clearInterval(timeline.timelineInterval);
  } else {
    timeline.timelineActiveStep ||= defaultActiveStep();
    timeline.timelineActiveShortStep = parseInt(timeline.timelineActiveStep.getAttribute('data-ts'));
    btn.classList.add('playing');
    btn.querySelector("i").classList.replace('fa-play', 'fa-pause');
    timeline.timelineInterval = setInterval(function() {
      timeline.timelineActiveShortStep += (timeline.timelineStep / 2);
      if ((timeline.timelineActiveShortStep % timeline.timelineStep !== 0) && isShortStep(timeline.timelineActiveShortStep)) {
        displayPiafLayer(timeline.timelineActiveShortStep);
      } else {
        updateTimelinePosition(selectedTs() + timeline.timelineStep);
      }
    }, 1200);
  }
}

export function defaultActiveStep() {
  return Array.from(document.querySelectorAll("#timeline_steps .tl_item.tl_obs")).pop() ||
    document.querySelector("#timeline_steps .tl_item:first-child");
}

export function nextStepTimeline() {
  console.debug('nextStepTimeline');
  let offset;
  timeline.timelineActiveShortStep ||= parseInt(timeline.timelineActiveStep.getAttribute('data-ts'));
  if (timeline.timelineActiveStep.nextSibling.getAttribute('data-rt')) {
    offset = timeline.timelineStep;
    updateTimelinePosition(selectedTs() + offset);
  } else {
    const ts = parseInt(timeline.timelineActiveStep.getAttribute('data-ts'));
    if (isShortStep(ts)) {
      timeline.timelineActiveShortStep += (timeline.timelineStep / 2);
      if (timeline.timelineActiveShortStep % timeline.timelineStep !== 0) {
        displayPiafLayer(timeline.timelineActiveShortStep);
      } else {
        updateTimelinePosition(selectedTs() + timeline.timelineStep);
      }
    } else {
      offset = (3600 - (ts % 3600));
      updateTimelinePosition(selectedTs() + offset);
    }
  }
  console.debug('timeline.timelineActiveShortStep: ' + new Date(timeline.timelineActiveShortStep * 1000));
  console.debug('timeline.timelineActiveStep: ' + new Date(timeline.timelineActiveStep.getAttribute('data-ts') * 1000));
}

export function prevStepTimeline() {
  console.debug('prevStepTimeline');
  let offset;
  if (timeline.timelineActiveStep.previousSibling.getAttribute('data-rt')) {
    offset = timeline.timelineStep;
  } else {
    const now = new Date().getTime() / 1000, ts = parseInt(timeline.timelineActiveStep.getAttribute('data-ts'));
    if (layers.dataLayers.indexOf('rain_fc') !== -1 && (ts - now) < 3600) {
      offset = timeline.timelineStep
    } else {
      offset = (3600 - (ts % 3600));
    }
  }
  updateTimelinePosition(selectedTs() - offset);
}

export function nextTimeline() {
  const activeTs = parseInt(timeline.timelineActiveStep.getAttribute('data-ts')),
    nextTs = activeTs + (3600 * 24);
  updateTimelinePosition(nextTs);
}

export function prevTimeline() {
  const activeTs = parseInt(timeline.timelineActiveStep.getAttribute('data-ts')),
    nextTs = activeTs - (3600 * 24);
  updateTimelinePosition(nextTs);
}

export function refreshTimeline() {
  defaultActiveStep().click();
}

function isShortStep(ts) {
  const now = new Date().getTime() / 1000;
  return layers.dataLayers.indexOf('rain_fc') !== -1 && Math.abs(ts - now) < 3600;
}

function selectedTs() {
  return d3.select(timeline.timelineActiveStep).datum()[0];
}

function selectTsTimeline(newTs) {
  console.log('selectTsTimeline: ' + (new Date(newTs * 1000)).toString());
  const now = new Date().getTime() / 1000,
    newItem = document.querySelector("#timeline_steps .tl_item[data-ts='" + newTs + "']");

  if (newItem) {
    toggleStepTimeline(newItem);
    updateTimelineDatetime(newTs, timeline.details);

    if (now > newTs && now - newTs < 660) {
      if (layers.dataLayers.indexOf('wind') !== -1) {
        refreshWindSensorsData();
      }
      if (layers.dataLayers.indexOf('waves') !== -1) {
        refreshWaveSensorsData();
      }
      if (layers.dataLayers.indexOf('temp') !== -1) {
        refreshTempSensorsData();
      }
      if (layers.dataLayers.indexOf('temp_water') !== -1) {
        displayWaterTemp();
      }
    } else {
      if (layers.dataLayers.indexOf('wind') !== -1) {
        renderWindSensors(Object.values(data.timelineData[newTs] || {}));
      }
      let lastWavesMeasureTs = newTs - (newTs % 1800), now = new Date().getTime() / 1000;
      if (now - lastWavesMeasureTs < 1800) {
        lastWavesMeasureTs = lastWavesMeasureTs - 1800;
      }
      if (layers.dataLayers.indexOf('waves') !== -1) {
        renderWaveSensors(Object.values(data.timelineData[lastWavesMeasureTs] || {}));
      }
      if (layers.dataLayers.indexOf('temp') !== -1) {
        renderTempSensors(Object.values(data.timelineData[newTs] || {}));
      }
    }

    debouncedRefreshForecasts();

    let isFuture = !newItem.classList.contains("tl_obs");
    document.body.classList.toggle('future_ts', isFuture);
    if (isFuture && layers.dataLayers.indexOf('waves_fc') === -1 && layers.dataLayers.indexOf('rain_fc') === -1) {
      if (layers.dataLayers.indexOf('wind_fc') === -1) {
        wm.toggleLayer(document.querySelector("#wind_fc"), 'wind_fc');
      }
    }
  }
  return newItem;
}

export function refreshForecastsLayers() {
  let ts = null, hourTs = null, rendered = document.querySelector("#map_container").classList.contains('rendered');
  if (timeline.timelineActiveStep) {
    ts = parseInt(timeline.timelineActiveStep.getAttribute('data-ts'));
    hourTs = timeline.timelineActiveStep.getAttribute('data-fc') ? ts : (ts - (ts % 3600));
  }

  if (layers.dataLayers.indexOf('wind_fc') !== -1) {
    if (map.windLayer) {
      map.windLayer.stop();
    }
    displayWindForecasts(hourTs).then(function () {
      if (map.currentFocus && config.popup) {
        displayForecastDetails(config.popup, map.currentFocus.lat, map.currentFocus.lng);
      }
    });
  }

  if (layers.dataLayers.indexOf('waves_fc') !== -1) {
    displayWavesForecasts(hourTs).then(function () {
      if (map.currentFocus && config.popup) {
        displayForecastDetails(config.popup, map.currentFocus.lat, map.currentFocus.lng);
      }
    });
  }

  if (layers.dataLayers.indexOf('weather_fc') !== -1) {
    displayPOIs(hourTs);
  }

  if (layers.dataLayers.indexOf('rain_fc') !== -1) {
    displayPiafLayer(ts);
  }
}

function setUpKeyboardActions() {
  window.addEventListener("keydown", function(e) {
    const activeModal = document.querySelector(".modal.is-open"),
      editMode = document.querySelector("#edit_spot_controls:not(.hidden)");
    if (!activeModal && !editMode) {
      switch(e.code) {
        case "ArrowLeft":
          e.stopPropagation();
          e.preventDefault();
          prevStepTimeline();
          break;
        case "ArrowRight":
          e.stopPropagation();
          e.preventDefault();
          nextStepTimeline();
          break;
        case "Escape":
          refreshTimeline();
          break;
        case "Space":
          e.stopPropagation();
          e.preventDefault();
          toggleTimeline(document.querySelector("#timeline_commands #tl_play"));
          break;
        default:
      }
    }
  }, true);
  timeline.keyBoardSetUp = true;
}

function updateTimelinePosition(newVal) {
  const newStep = computeStep(newVal), xAdjustment = 0;
  const xPos = timeline.details ? ((newStep + xAdjustment) * timeline.detailsStepWidth) : ((newStep + xAdjustment) * timeline.stepWidth);
  timeline.timelineSlider.setPosition({x: xPos - layout.width / 2, y: 0});
}

function computeStep(ts) {
  console.debug('computeStep: ' + new Date(ts * 1000) + ' - step index: ' + (timeline.timelineSteps.findIndex(s => s[0] <= ts && s[1] > ts)).toString());
  return timeline.timelineSteps.findIndex(s => s[0] <= ts && s[1] > ts);
}
